(function () {
  'use strict';

  var productCache = {}; // handle → full product object
  var lastCart = null;   // latest cart snapshot (for GA4 remove_from_cart)
  var cartConfig = null; // discount/shipping thresholds injected via #pwb-cart-config

  function init() {
    // Listen on document so foster-parented tbody structure never breaks delegation
    document.addEventListener('click', onDocClick);
    document.addEventListener('change', onDocChange);

    // Seed the cart snapshot from the JSON the section already embeds; kept in
    // sync from every /cart/change.js response below.
    var seed = document.getElementById('ProductJson-cart-template');
    if (seed) { try { lastCart = JSON.parse(seed.textContent); } catch (e) { lastCart = null; } }
    if (lastCart) window.pwbLastCart = lastCart; // shared snapshot for GA4 begin_checkout

    cartConfig = readCartConfig();

    // Fetch selling plans for ALL cart rows — show/hide the select based on what's available
    document.querySelectorAll('tr[data-variant-id]').forEach(function (row) {
      fetchProductForRow(row);
    });
  }

  // ── Click: qty +/- and remove ────────────────────────────────────

  function onDocClick(e) {
    if (!e.target.closest('#cartform')) return;

    var btn = e.target.closest('[data-action]');
    if (!btn) return;

    var action = btn.dataset.action;
    var row = btn.closest('tr[data-line]');
    if (!row) return;

    e.preventDefault();

    if (action === 'qty-minus' || action === 'qty-plus') {
      var inputs = row.querySelectorAll('.pwb-qty-input');
      var delta = action === 'qty-minus' ? -1 : 1;
      var newQty = Math.max(0, parseInt(inputs[0].value, 10) + delta);
      inputs.forEach(function (inp) { inp.value = newQty; });
      applyChange(row, { quantity: newQty });

    } else if (action === 'remove') {
      // GA4 remove_from_cart: emit before the line is gone, resolving its full
      // data from the current cart snapshot.
      dispatchRemoveForRow(row);
      applyChange(row, { quantity: 0 });

    } else if (action === 'show-plans') {
      // Reveal the "Delivery:" label + selling plan select, hide the subscribe button
      var wrap = btn.closest('.pwb-selling-plan-wrap');
      if (wrap) {
        btn.style.display = 'none';
        var label = wrap.querySelector('.pwb-plan-label');
        var sel   = wrap.querySelector('.pwb-selling-plan-select');
        if (label) label.style.display = 'inline';
        if (sel) {
          sel.style.display = '';
          // Open the native dropdown immediately so the customer can just
          // pick a frequency. showPicker() requires the current user gesture
          // (this click) and no-ops on browsers that don't support it.
          sel.focus();
          try { sel.showPicker(); } catch (e) {}
        }
      }
    }
  }

  // ── Change: qty input and selling plan select ─────────────────────

  var qtyTimer = null;
  function onDocChange(e) {
    if (!e.target.closest('#cartform')) return;

    var el = e.target;
    var row = el.closest('tr[data-line]');
    if (!row) return;

    if (el.classList.contains('pwb-qty-input')) {
      clearTimeout(qtyTimer);
      // Keep mobile + desktop inputs in sync
      row.querySelectorAll('.pwb-qty-input').forEach(function (inp) {
        if (inp !== el) inp.value = el.value;
      });
      var qty = Math.max(0, parseInt(el.value, 10) || 0);
      qtyTimer = setTimeout(function () { applyChange(row, { quantity: qty }); }, 500);

    } else if (el.classList.contains('pwb-selling-plan-select')) {
      var planVal = el.value;
      row.querySelectorAll('.pwb-selling-plan-select').forEach(function (s) { s.value = planVal; });
      // Preserve the line's current quantity. /cart/change.js resets the line
      // quantity to 1 when only `selling_plan` is sent, so pass `quantity`
      // explicitly to keep it (and to keep the qty input in sync).
      var planQtyInput = row.querySelector('.pwb-qty-input');
      var planQty = planQtyInput ? Math.max(1, parseInt(planQtyInput.value, 10) || 1) : 1;
      var payload = {
        selling_plan: planVal === '' ? '' : parseInt(planVal, 10),
        quantity: planQty
      };
      applyChange(row, payload);
    }
  }

  // ── Shopify /cart/change.js (use `line`, always a valid integer) ──

  function applyChange(row, changes) {
    var line = parseInt(row.dataset.line, 10);
    if (!line) { console.error('[pwb-cart] row missing data-line', row); return; }

    setRowBusy(row, true);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(Object.assign({ line: line }, changes))
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || d.message || 'Error updating cart'); });
        return res.json();
      })
      .then(function (cart) {
        if (changes.quantity === 0) {
          removeRow(row);
          if (cart.item_count === 0) {
            setTimeout(function () { window.location.reload(); }, 320);
            return;
          }
          // Re-sync remaining rows (line index, prices, discounts) — a removal
          // can change cart-level discount allocations on other lines
          refreshAllRows(cart, row);
        } else {
          setRowBusy(row, false);
          // Line position is unchanged for qty/selling_plan edits
          var item = cart.items[line - 1];
          if (item) {
            if (changes.selling_plan !== undefined) {
              if (item.selling_plan_allocation) {
                row.dataset.sellingPlan = String(item.selling_plan_allocation.selling_plan.id);
              } else {
                delete row.dataset.sellingPlan;
              }
              // Re-populate select options with updated selection
              var handle = row.dataset.productHandle;
              if (handle && productCache[handle]) populatePlanSelects(row, productCache[handle]);
              // If switched back to one-time: hide select + label, show subscribe button
              if (!item.selling_plan_allocation) {
                row.querySelectorAll('.pwb-selling-plan-select').forEach(function (s) { s.style.display = 'none'; });
                row.querySelectorAll('.pwb-plan-label').forEach(function (l) { l.style.display = 'none'; });
                row.querySelectorAll('.pwb-subscribe-btn').forEach(function (b) { b.style.display = ''; });
              }
            }
          }
          // Refresh every row, not just the edited one — qty/plan changes can
          // add or remove threshold-based discounts on other lines
          refreshAllRows(cart);
        }
        refreshCartTotals(cart);
        refreshBadge(cart);
        refreshSummary(cart);
        lastCart = cart; // keep snapshot current for subsequent remove events
        window.pwbLastCart = cart; // …and for GA4 begin_checkout on submit
      })
      .catch(function (err) {
        console.error('[pwb-cart]', err);
        setRowBusy(row, false);
        flashError(err.message);
      });
  }

  // ── GA4 events ────────────────────────────────────────────────────
  // Resolve the row's full line-item from the cart snapshot and emit a
  // remove event; ga4_generic.liquid turns it into a dataLayer push.
  function dispatchRemoveForRow(row) {
    if (!lastCart || !lastCart.items) return;
    var key = row.dataset.key;
    var line = parseInt(row.dataset.line, 10);
    var item = key
      ? lastCart.items.filter(function (it) { return it.key === key; })[0]
      : null;
    if (!item && line) item = lastCart.items[line - 1];
    if (!item) return;
    try { document.dispatchEvent(new CustomEvent('pwb:remove-from-cart', { detail: { item: item } })); }
    catch (e) { /* CustomEvent unsupported — skip analytics, never block the cart */ }
  }

  // ── DOM helpers ───────────────────────────────────────────────────

  // Re-sync all rows against the returned cart: line index, key, prices and
  // line-level discounts. `excludeRow` skips a row that is animating out.
  function refreshAllRows(cart, excludeRow) {
    var rows = Array.prototype.filter.call(
      document.querySelectorAll('#cartform tr[data-line]'),
      function (r) { return r !== excludeRow; }
    );
    rows.forEach(function (row, i) {
      var item = cart.items[i];
      if (!item) return;
      row.dataset.line = i + 1;
      row.dataset.key = item.key;
      refreshRowPrices(row, item);
    });
  }

  function setRowBusy(row, busy) {
    row.style.opacity = busy ? '0.45' : '';
    row.style.pointerEvents = busy ? 'none' : '';
  }

  function removeRow(row) {
    row.style.transition = 'opacity 0.28s ease, transform 0.28s ease';
    row.style.opacity = '0';
    row.style.transform = 'translateX(18px)';
    setTimeout(function () { if (row.parentNode) row.parentNode.removeChild(row); }, 300);
  }

  function refreshRowPrices(row, item) {
    // Use final_price (per-unit price after line-level discounts) to match the
    // Liquid render — cart.js `price` is the pre-discount price and would make
    // the unit price jump on the first AJAX update.
    row.querySelectorAll('.pwb-unit-price').forEach(function (el) {
      el.textContent = formatMoney(item.final_price);
    });
    row.querySelectorAll('.pwb-line-price').forEach(function (el) {
      el.textContent = formatMoney(item.final_line_price);
    });
    refreshRowDiscounts(row, item);
  }

  // Rebuild the discount labels (mirrors the Liquid capture in
  // main-cart-items.liquid) into both the mobile row and the desktop total
  // column so they stay in sync after an AJAX cart change.
  function refreshRowDiscounts(row, item) {
    var html = buildDiscountHtml(item);
    row.querySelectorAll('.pwb-line-discount, .pwb-mobile-discount').forEach(function (c) {
      c.innerHTML = html;
    });
  }

  // Subscription line → "Subscription Discount: X%"; otherwise the cart-level
  // discount allocation labels.
  function buildDiscountHtml(item) {
    if (item.selling_plan_allocation) {
      return '<small class="cart__discount">Subscription Discount: '
        + esc(subscriptionDiscountPercent(item)) + '</small>';
    }
    return (item.line_level_discount_allocations || []).map(function (alloc) {
      return '<small class="cart__discount">'
        + esc(alloc.discount_application.title) + ' (-' + formatMoney(alloc.amount) + ')'
        + '</small>';
    }).join('');
  }

  // Subscription discount as a "12%"-style string. Prefers the 'Subscription
  // Discount' line-item property this theme writes; falls back to computing it
  // from the selling plan allocation's prices.
  function subscriptionDiscountPercent(item) {
    if (item.properties && item.properties['Subscription Discount']) {
      return String(item.properties['Subscription Discount']);
    }
    var alloc = item.selling_plan_allocation;
    if (alloc && alloc.compare_at_price && alloc.price && alloc.compare_at_price > alloc.price) {
      return Math.round((alloc.compare_at_price - alloc.price) / alloc.compare_at_price * 100) + '%';
    }
    return '';
  }

  function refreshCartTotals(cart) {
    var el = document.getElementById('pwb-cart-total');
    if (el) el.textContent = formatMoney(cart.total_price);
  }

  // Recompute the cart-wide, threshold-based messages that a single-line change
  // can flip: the order-level "Save 10% / You saved" note and the free-shipping
  // banner. Thresholds are injected server-side via #pwb-cart-config so we don't
  // duplicate the theme settings here. Mirrors the Liquid in main-cart-items.liquid.
  function refreshSummary(cart) {
    recomputeOrderNote(cart);
    recomputeFreeShipping(cart);
  }

  function recomputeOrderNote(cart) {
    if (!cartConfig) return;
    var noteEl = document.getElementById('pwb-order-discount-note');
    if (!noteEl) return;

    // Hidden for subscription orders or when the merchant disabled the note.
    // (Liquid also treats a 'subscription'-tagged product as a subscription
    // order; here we key off selling_plan_allocation, the operative signal.)
    var subscriptionOrder = (cart.items || []).some(function (it) { return !!it.selling_plan_allocation; });
    if (subscriptionOrder || cartConfig.volumeOff) { noteEl.style.display = 'none'; return; }
    noteEl.style.display = '';

    var totalSaving = (cart.items || []).reduce(function (sum, it) {
      return sum + (it.line_level_total_discount || 0);
    }, 0);
    var threshold = cartConfig.volumeThreshold || 0;
    var inner = noteEl.querySelector('.order_discount_note');
    if (!inner) return;

    var msg;
    if (totalSaving < 1 && cart.total_price < threshold) {
      msg = '<strong>Save 10%</strong> on all orders over ' + formatMoney(threshold)
          + ' (You are <strong>' + formatMoney(threshold - cart.total_price) + '</strong> away!)';
    } else {
      msg = 'You saved ' + formatMoney(totalSaving);
    }
    msg += '<br>There will be the opportunity to enter a promo code before completing checkout';
    inner.innerHTML = msg;
  }

  function recomputeFreeShipping(cart) {
    if (!cartConfig) return;
    var el = document.getElementById('pwb-free-shipping');
    if (!el) return;
    var threshold = cartConfig.freeShippingThreshold || 0;
    if (cart.total_price > threshold) {
      el.innerHTML = '<a href="/policies/shipping-policy">You\'ve qualified for Free Shipping '
        + '<span style="color: #86c440;font-size: 18px;font-weight: bold;">✓</span></a>';
    } else {
      el.innerHTML = '<a href="/policies/shipping-policy">FREE SHIPPING on orders over ' + formatMoney(threshold) + '</a>';
    }
  }

  function readCartConfig() {
    var el = document.getElementById('pwb-cart-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function refreshBadge(cart) {
    document.querySelectorAll('.pwb_cart_mark, .pwb_sticky_cart_mark').forEach(function (el) {
      el.textContent = cart.item_count;
    });
    var sticky = document.getElementById('pwb_sticky_cart');
    if (sticky) sticky.style.display = cart.item_count > 0 ? 'block' : 'none';
    var drawerCount = document.getElementById('pwb-drawer-count');
    if (drawerCount) drawerCount.textContent = cart.item_count > 0 ? cart.item_count : '';
  }

  function flashError(msg) {
    var el = document.getElementById('pwb-cart-page-error');
    if (!el) {
      el = document.createElement('div');
      el.id = 'pwb-cart-page-error';
      el.className = 'pwb-atc-error';
      var form = document.getElementById('cartform');
      if (form) form.insertAdjacentElement('beforebegin', el);
    }
    el.textContent = msg;
    setTimeout(function () { el.textContent = ''; }, 5000);
  }

  // ── Selling plan selects ──────────────────────────────────────────

  function fetchProductForRow(row) {
    var handle = row.dataset.productHandle;
    if (!handle) return;

    if (productCache[handle] !== undefined) {
      populatePlanSelects(row, productCache[handle]);
      return;
    }

    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (product) {
        productCache[handle] = product;
        // Populate all rows for this product (handles duplicate products in cart)
        document.querySelectorAll('tr[data-product-handle="' + handle + '"]').forEach(function (r) {
          populatePlanSelects(r, product);
        });
      })
      .catch(function () {
        productCache[handle] = { selling_plan_groups: [], variants: [] };
      });
  }

  function populatePlanSelects(row, product) {
    var selects = row.querySelectorAll('.pwb-selling-plan-select');
    if (!selects.length) return;

    var variantId = parseInt(row.dataset.variantId, 10);
    var currentPlan = row.dataset.sellingPlan || '';
    var groups = product.selling_plan_groups || [];

    // Collect plan IDs valid for this specific variant, plus the variant price
    // (needed to compute the "Save X%" label for each subscription group).
    var validPlanIds = new Set();
    var variantPrice = 0;
    (product.variants || []).forEach(function (v) {
      if (v.id === variantId) {
        variantPrice = v.price;
        (v.selling_plan_allocations || []).forEach(function (a) {
          validPlanIds.add(a.selling_plan_id);
        });
      }
    });

    var hasPlans = false;
    var options =
      '<optgroup label="One Time Purchase">' +
        '<option value=""' + (currentPlan === '' ? ' selected' : '') + '>One-time</option>' +
      '</optgroup>';

    groups.forEach(function (group) {
      var plans = (group.selling_plans || []).filter(function (plan) {
        return validPlanIds.size === 0 || validPlanIds.has(plan.id);
      });
      if (!plans.length) return;
      hasPlans = true;

      var save = planDiscountPercent(plans[0], variantPrice);
      var label = esc(group.name) + (save ? ' (Save ' + save + ')' : '');

      var groupOptions = '';
      plans.forEach(function (plan) {
        var sel = String(plan.id) === String(currentPlan) ? ' selected' : '';
        groupOptions += '<option value="' + plan.id + '"' + sel + '>' + esc(plan.name) + '</option>';
      });

      options += '<optgroup label="' + label + '">' + groupOptions + '</optgroup>';
    });

    selects.forEach(function (select) {
      select.innerHTML = options;
    });

    // Show the wrapper only if this variant actually has selling plans
    row.querySelectorAll('.pwb-selling-plan-wrap').forEach(function (wrap) {
      wrap.style.display = hasPlans ? '' : 'none';
    });
  }

  // ── Utils ─────────────────────────────────────────────────────────

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Returns a "12%"-style savings string for a selling plan given the variant
  // price, or '' if it can't be computed.
  function planDiscountPercent(plan, price) {
    var adj = plan && plan.price_adjustments && plan.price_adjustments[0];
    if (!adj || !price) return '';
    switch (adj.value_type) {
      case 'percentage':
        return adj.value + '%';
      case 'fixed_amount':
        return Math.round((adj.value / price) * 100) + '%';
      case 'price':
        return Math.round(((price - adj.value) / price) * 100) + '%';
      default:
        return '';
    }
  }

  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
